import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import gTabMenu from "@/components/g-tab-menu/g-tab-menu.vue";

const name = 'ParcelasPedidoEmAndamento'

export default {
  name,

  components:{
    "g-button": gButton,
    "g-card": gCard,
    "g-pdf": gPdf,
    "g-tab-menu": gTabMenu
  },

  props: {},

  mounted() {
    this.mitt.on('apareceTab', (indexAba) => {
      this.items[indexAba].flag = true
    })


    // this.mitt.on('removeTab', (listaIndex) => {
    //   listaIndex.forEach(e => this.items[e].flag = false)
    // })


    this.getNumeroParcela()
   },

  updated() { },

  data() {
    return {
        numeroParcela: null,
        FlagDashboard: false,
        items: [
          {label: 'Detalhes', to: `/pedido-em-andamento-fluxo/${this.$route.params.id}/detalhes-pedido-andamento`,  flag: true, index: 0},
          // {label: 'Histórico', to: `/pedido-em-andamento-fluxo/${this.$route.params.id}/${this.$route.params.numeroParcela}/historico-pedido-andamento`,  flag: false, index: 1},
          // {label: 'Nota Fiscal', to: `/pedido-em-andamento-fluxo/${this.$route.params.id}/nota-fiscal-pedido-andamento`,  flag: false, index: 2},
          {label: 'Parcelas', to: `/pedido-em-andamento-fluxo/${this.$route.params.id}/parcelas-pedido-andamento`,  flag: true, index: 3 },
          // {label: 'Observações', to: `/pedido-em-andamento-fluxo/${this.$route.params.id}/${this.$route.params.numeroParcela}/observacoes-pedido-andamento`,  flag: false, index: 4},
          // {label: 'Instruções Carregamento', to: `/pedido-em-andamento-fluxo/${this.$route.params.id}/${this.$route.params.numeroParcela}/instrucoes-carregamento-pedido-andamento`,  flag: false, index: 5},
        ],
        itemAtivoTeste: 0
    }
  },

  methods: {
    getNumeroParcela() {
      // this.numeroParcela = this.$store.state
    },

    tabChange(){
      if (this.itemAtivoTeste === 0) {
        this.mitt.emit('removeTab', [1, 2, 4, 5])
      }
    }
  },

  computed: { }
};